import { RedirectError } from './common';
import { InvalidParam, saneString } from './sanitizers';
export default class Scope {
    getQueryParam(...args) {
        return this.getParam('query', args, false)[0];
    }
    getQueryParams(...args) {
        return this.getParam('query', args, true);
    }
    getPathParam(...args) {
        return this.getParam('path', args, false)[0];
    }
    getParam(source, args, multi) {
        const name = args[0];
        const sanitizer = typeof args[1] === 'function' ? args[1] : saneString;
        const fallback = [typeof args[1] === 'function' ? args[2] : args[1]].flat().filter(v => v !== undefined).map(v => `${v}`);
        const rawValue = this.getParamValue(name, source);
        if (!rawValue || rawValue.length === 0) {
            if (source === 'query' && fallback.length > 0)
                throw this.fixParam(name, source, fallback);
            else
                return [];
        }
        const results = rawValue.map(input => {
            try {
                return { input, output: sanitizer(input) };
            }
            catch (error) {
                if (error instanceof InvalidParam)
                    return { error };
                else
                    throw error;
            }
        });
        if (results.some(r => r.error)) {
            const remainingResults = results.filter(r => !r.error || r.error.newValue !== undefined);
            if (remainingResults.length === 0) {
                // special treatment of empty values - crucial for paths but also for query parameters that require a distinction between "not present" and "empty"
                if (rawValue[0] === '')
                    return [];
                if (fallback.length > 0)
                    throw this.fixParam(name, source, fallback);
            }
            const newValues = remainingResults.map(r => r.error ? r.error.newValue : r.input);
            throw this.fixParam(name, source, multi ? newValues : newValues[0]);
        }
        if (!multi && results.length > 1)
            throw this.fixParam(name, source, results[0].input);
        return results.map(r => r.output);
    }
    /**
     * Removes all query parameters with the given name by performing a redirect.
     * If no parameters are found this has no effect (other than dependency tracking).
     * @param name
     */
    removeQueryParams(name) {
        const rawValue = this.getParamValue(name, 'query');
        if (rawValue && rawValue.length > 0)
            throw this.fixParam(name, 'query', undefined);
    }
    fixParam(name, source, value) {
        const key = source === 'path' ? 'params' : 'query';
        // pass value in a deterministic way to facilitate testing
        const valueNormalized = Array.isArray(value) && value.length < 2 ? value[0] : value;
        return new RedirectError({ [key]: { [name]: valueNormalized } });
    }
}
